import React from 'react';
import createSvgIcon from '@material-ui/icons/utils/createSvgIcon';

export default createSvgIcon(
  <path d="M17 5C19.7614 5 22 7.23858 22 10C22 12.7614 19.7614 15 17 15H9C7.34315 15 6 13.6569 6 12C6 10.3431 7.34315 9 9 9H17C17.5523 9 18 9.44772 18 10C18 10.5523 17.5523 11 17 11H9L8.88338 11.0067C8.38604 11.0645 8 11.4872 8 12C8 12.5128 8.38604 12.9355 8.88338 12.9933L9 13H17C18.6569 13 20 11.6569 20 10C20 8.34315 18.6569 7 17 7H9C6.23858 7 4 9.23858 4 12C4 14.6888 6.12231 16.8818 8.78311 16.9954L9 17H17C17.5523 17 18 17.4477 18 18C18 18.5523 17.5523 19 17 19H9C5.13401 19 2 15.866 2 12C2 8.13401 5.13401 5 9 5H17Z" />,
  'Attachment'
);
